import { createContext, useContext, useState, ReactNode } from 'react'

// 1. Define the type interface for the context shape
interface QuoteContextType {
	isOpen: boolean
	openQuoteModal: () => void
	closeQuoteModal: () => void
}

// 2. Initialize with type definition and default fallback value
const QuoteContext = createContext<QuoteContextType | undefined>(undefined)

export const QuoteProvider = ({ children }: { children: ReactNode }) => {
	const [isOpen, setIsOpen] = useState<boolean>(false)

	const openQuoteModal = () => setIsOpen(true)
	const closeQuoteModal = () => setIsOpen(false)

	return (
		<QuoteContext.Provider value={{ isOpen, openQuoteModal, closeQuoteModal }}>
			{children}
		</QuoteContext.Provider>
	)
}

export const useQuoteModal = (): QuoteContextType => {
	const context = useContext(QuoteContext)
	if (!context) {
		throw new Error('useQuoteModal must be used within a QuoteProvider')
	}
	return context
}
